import { render, staticRenderFns } from "./LeftSatellite.vue?vue&type=template&id=662912a6&"
import script from "./LeftSatellite.vue?vue&type=script&lang=js&"
export * from "./LeftSatellite.vue?vue&type=script&lang=js&"
import style0 from "./LeftSatellite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports